<template>
    
    <CookieWarning v-if="currentLanguage === 'ro'" :section_title="section_title_ro" :cookie_policy="cookie_policy_ro"/>
    <CookieWarning v-else :section_title="section_title_en" :cookie_policy="cookie_policy_en"/>

</template>

<script>
import axios from 'axios';
import CookieWarning from '@/components/CookieWarning.vue';

export default {
    components: {
        CookieWarning
    },
    data() {
        return {
            cookieData: {
                items_ro: [{ section_title: '', cookie_policy: '' }],
                items_en: [{ section_title: '', cookie_policy: '' }],
            },
            section_title_ro: '',
            section_title_en: '',
            cookie_policy_ro: '',
            cookie_policy_en: '',

        }
    },
    computed: {
        currentLanguage() {
            return this.$store.getters.getCurrentLanguage;
        },
    },
    created() {
        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    },
    mounted() {
        const token = 'b246eda339b1157fda4c9795dbc4150851e94fbb';

        axios.get('https://app-landing-page-ro-backend-dev.azurewebsites.net/api/cookie-policy-content', {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.cookieData = response.data || { items_ro: [], items_en: [] };

                if (this.cookieData.items_ro[0].active === true) {
                    this.section_title_ro = this.cookieData.items_ro[0].section_title;
                    this.cookie_policy_ro = this.cookieData.items_ro[0].cookie_policy;
                }
                if (this.cookieData.items_en[0].active === true) {
                    this.section_title_en = this.cookieData.items_en[0].section_title;
                    this.cookie_policy_en = this.cookieData.items_en[0].cookie_policy;
                }
            })
            .catch(error => {
                console.error('Error fetching cookie warning data:', error);
            });


        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    }
}
</script>

<style></style>